// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e0ltbq {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  height: 100%;
}

.xuXyzO {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: var(--radius-s);
  overflow: hidden;
  position: relative;
  min-height: 0;
  flex: 1;
}

.KLc1Bb {
  width: 100%;
  height: 48px;
  padding-left: var(--spacing-3);
  padding-right: var(--spacing-3);
  padding-top: var(--spacing-1-5);
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  gap: var(--spacing-1-5);
}

.OL4vwW {
  height: 36px;
  padding: var(--spacing-1);
  text-align: center;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  box-sizing: border-box;
}

.a8b2TO {
  height: 36px;
  padding: var(--spacing-1);
  text-align: center;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-medium);
  background: transparent;
  border: none;
  border-bottom: 2px solid var(--brand-tr-orange);
  cursor: pointer;
  box-sizing: border-box;
}

.i2N2jH {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  gap: var(--spacing-3);
}

.HhNiX8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: var(--spacing-2);
}

.os9xXL {
  height: 24px;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-1);
}

.LSbMF4 {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-medium);
}

.dQxGre {
  background: transparent;
}

.dR9RZR {
  background: transparent !important;
}

.hPGVyG,
.hPGVyG img {
  background-color: var(--surface-neutral-inverted, #ffffff) !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/Extract/Extract.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,qDAAqD;EACrD,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4EAA4E;EAC5E,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,qEAAqE;AACvE","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  height: 100%;\n}\n\n.section {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n  border-radius: var(--radius-s);\n  overflow: hidden;\n  position: relative;\n  min-height: 0;\n  flex: 1;\n}\n\n.header {\n  width: 100%;\n  height: 48px;\n  padding-left: var(--spacing-3);\n  padding-right: var(--spacing-3);\n  padding-top: var(--spacing-1-5);\n  display: flex;\n  align-items: flex-end;\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  gap: var(--spacing-1-5);\n}\n\n.title {\n  height: 36px;\n  padding: var(--spacing-1);\n  text-align: center;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.titleSelected {\n  height: 36px;\n  padding: var(--spacing-1);\n  text-align: center;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary-medium);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid var(--brand-tr-orange);\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  gap: var(--spacing-3);\n}\n\n.top {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: var(--spacing-2);\n}\n\n.filters {\n  height: 24px;\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--spacing-1);\n}\n\n.clearFiltersButton {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary-medium);\n}\n\n.iconContainer {\n  background: transparent;\n}\n\n.iconContainerOtherBanks {\n  background: transparent !important;\n}\n\n.avatar,\n.avatar :global(img) {\n  background-color: var(--surface-neutral-inverted, #ffffff) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `e0ltbq`,
	"section": `xuXyzO`,
	"header": `KLc1Bb`,
	"title": `OL4vwW`,
	"titleSelected": `a8b2TO`,
	"body": `i2N2jH`,
	"top": `HhNiX8`,
	"filters": `os9xXL`,
	"clearFiltersButton": `LSbMF4`,
	"iconContainer": `dQxGre`,
	"iconContainerOtherBanks": `dR9RZR`,
	"avatar": `hPGVyG`
};
module.exports = ___CSS_LOADER_EXPORT___;
